export default __webpack_public_path__ + "static/media/aprovado.ac10dbee.png";